import { Edit, MoreHorizontal } from "lucide-react";
import { useState } from "react";
import { LotEditDialog } from "./LotEditDialog";
import { type SupplyChainLot } from "./index";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface LotActionMenuProps {
  lot: SupplyChainLot;
  onLotUpdated?: () => void;
}

export function LotActionMenu({ lot, onLotUpdated }: LotActionMenuProps) {
  const [editModalOpen, setEditModalOpen] = useState(false);

  if (!lot) return null;

  const handleEditLot = () => {
    setEditModalOpen(true);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handleEditLot}>
            <Edit className="mr-2 h-4 w-4" />
            Edit
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <LotEditDialog lot={lot} open={editModalOpen} onOpenChange={setEditModalOpen} onSuccess={onLotUpdated} />
    </>
  );
}
